var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc2",class:Object.assign(( _obj = {
    textarea: _vm.textarea,
    valued: _vm.valued,
    disabled: this.disabled
  }, _obj[_vm.fcType] = true, _obj ),
    {'no-disabled-style': _vm.noDisabledStyle},
    _vm.classDict),style:({
    height: _vm.heightC,
    '--fc2-lw': _vm.lw,
    '--fc2-cw': _vm.cw,
    '--fc2-height': _vm.heightC,
    '--bb': _vm.bb || "1px solid var(--sprt-85)",
  })},[(_vm.showLabel)?_c('label',{staticClass:"fc2-label txtov",attrs:{"title":_vm.label,"for":_vm.id}},[_c('span',[_vm._v(_vm._s(_vm.label)+" ")]),(_vm.hint && _vm.hintHTML)?_c('v-menu',{attrs:{"open-on-hover":"","bottom":"","left":"","offset-y":"","max-width":"768"}},[_c('img',{staticClass:"dt-icon v5 s20 fc2-hint",attrs:{"slot":"activator","src":"static/icons/help.svg","alt":_vm.hint},slot:"activator"}),_c('v-card',{staticStyle:{"padding":"8px"}},[_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.hint)}})])])],1):_vm._e(),(_vm.hint && !_vm.hintHTML)?_c('img',{staticClass:"dt-icon v5 s20 fc2-hint",attrs:{"title":_vm.hint,"src":"static/icons/help.svg","alt":_vm.hint}}):_vm._e()],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }